export const FETCHING = 'misc/FETCHING'
export const FETCHING_ERROR = 'misc/FETCHING_ERROR'
export const FETCHING_SUCCESS = 'misc/FETCHING_SUCCESS'
